import { SvgIconType } from './svg.interface';

const Doctor: SvgIconType = ({
  width = 46,
  height = 46,
  className = '',
  color = 'white'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.5885 11.0327C33.5885 17.131 28.8698 22.0315 23.0002 22.0315C17.2458 22.0315 12.412 17.2399 12.412 11.1416C12.412 5.04325 17.1307 0.142822 23.0002 0.142822C28.8698 0.142822 33.5885 4.93435 33.5885 11.0327ZM3 43.3174V30.5097C3 28.1698 4.4865 26.0762 6.91893 25.2141C8 24.8447 9.08108 24.4752 10.1622 24.2289C8.94597 26.3225 8.81081 28.5392 9.08108 30.1402C6.24325 31.4949 5.16218 34.6968 6.51352 37.283L8.4054 41.2239C8.81081 41.9628 9.62161 42.3322 10.4324 41.9628C11.2432 41.5933 11.6486 40.8544 11.2432 40.1155L9.48649 36.1746C8.67568 34.82 9.62163 32.9727 11.3784 32.4801C13.1351 32.2338 14.6216 32.9727 14.8919 34.9431L15.1622 39.3766C15.1622 40.1155 15.973 40.7312 16.7838 40.7312C17.5946 40.7312 18.2703 39.9923 18.2703 39.2534L18 34.9431C17.7297 31.8643 15.1622 29.7707 12.1892 29.6476C12.0541 28.1698 12.1892 25.4604 15.1622 23.3668C15.2297 23.3668 15.3311 23.3361 15.4324 23.3053C15.5338 23.2745 15.6351 23.2437 15.7027 23.2437L21.5135 33.8347C22.0541 34.9431 23.8108 34.9431 24.3514 33.8347L30.1622 23.2437C31.2432 23.3668 32.3243 23.6131 33.4054 23.8595C33.946 25.2141 35.0271 28.2929 34.6216 30.8791C32.0541 31.2486 30.1622 33.3421 30.1622 35.8052C30.1622 38.5145 32.5946 40.7312 35.5676 40.7312C38.5406 40.7312 40.973 38.5145 40.973 35.8052C40.973 33.7116 39.6217 31.9875 37.7298 31.2486C38.1352 29.0318 37.5946 26.5688 37.0541 24.8447C37.5757 24.9397 38.0168 25.1082 38.5017 25.2934L38.5018 25.2935C38.645 25.3481 38.792 25.4043 38.946 25.4604C41.3784 26.3225 43 28.4161 43 30.7559L43 43.3174C43 44.7201 41.8629 45.8571 40.4603 45.8571H5.53968C4.13705 45.8571 3 44.7201 3 43.3174ZM35.5677 33.5871C36.7839 33.5871 37.865 34.5723 37.865 35.6806C37.865 36.789 36.7839 37.7742 35.5677 37.7742C34.3515 37.7742 33.2704 36.789 33.2704 35.6806C33.2704 34.5723 34.3515 33.5871 35.5677 33.5871Z"
      fill={color}
    />
  </svg>
);

export default Doctor;
